<div class="ui-g">
  <div class="ui-g-12">
    <p-checkbox label="Map Mode" [(ngModel)]="isMapMode" binary="true"></p-checkbox>
  </div>
  <div class="ui-g-12">
    <jobs-tasks-grid
      *ngIf="!isMapMode"
      [inboxType]="inboxType"
      [customers]="customers"
      [suppliers]="suppliers"
      #taskgrid
      (selectedTaskChange)="onTaskChanged($event)"
      (totalCountChanged)="totalCountChange($event)"
    ></jobs-tasks-grid>
    <jobs-tasks-live
      *ngIf="isMapMode"
      [inboxType]="inboxType"
      [customers]="customers"
      [suppliers]="suppliers"
      (selectedTaskChange)="onTaskChanged($event)"
    ></jobs-tasks-live>
  </div>
</div>
